module.exports = "https://la-static.vkplay.ru/promo/universal/img/promo-bg.0fda315b.jpg";